import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TABLES } from '../../../../../Apis/Tables';
import { AssignCardToUser, RemoveCardToUser } from '../../../../../reduxToolkit/Cards/CardsApi';
import { useTranslation } from 'react-i18next';
import { ACTION_MODEL } from './../../../../../Helpers/ActionModel';
import { useParams } from 'react-router-dom';
import {toast} from "react-toastify";
import {errorMsg} from "../../../../../Apis/functions";
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const Step7CardApp = ({ componentAction, userData }) => {
    const dispatch = useDispatch();
    const [searchElement, setSearchElement] = useState('');
    const [results, setResults] = useState([]);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [search, setSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const option = TABLES.CARD;
    const elementRef = useRef(null);
    const { t } = useTranslation();
    const { id } = useParams();

    /**
     * Dynamically calculates top position for floating search results.
     */
    useLayoutEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 100;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, [results?.content]);

    /**
     * Assigns a card to the current employee.
     * Only executes in update mode.
     *
     * @param {Object} card Selected card
     */
    const handleAddCard = async (item) => {
        const body = {
            userId: id,
            cardIds: [item.id],
        };
        const response = await dispatch(AssignCardToUser(body));

        if (response?.payload?.data?.success) {
            setModified(true);
            toast.success(t('has_been_assigned_successfully'));
        }else{
            errorMsg(response?.payload?.data?.code)
        }

        return response?.payload?.data?.success;
    };

    /**
     * Removes a card assignment from the current employee.
     * Only executes in update mode.
     *
     * @param {Object} card Selected card
     */
    const handleUnassingCard = (card) => {
        if (componentAction !== ACTION_MODEL.UPDATE) return;

        const body = {
            cardIds: [card.id],
            userId: userData.id,
        };

        dispatch(RemoveCardToUser(body)).then(async({ payload }) => {
            const success = payload?.data?.success;
            const code = payload?.data?.code;
            if (success) {
                setModified(true);
            }else{
                errorMsg(code);
            }
        });
    };

    return {
        searchElement,
        setSearchElement,
        results,
        setResults,
        setSimpleSearch,
        setSearch,
        option,
        elementRef,
        dispatch,
        t,
        modified,
        setModified,
        handleAddCard,
        handleUnassingCard,
    };
};

export default Step7CardApp;
